export default __webpack_public_path__ + "static/media/pluck.ffdde42f.mp3";